import type { Country } from '../types/mortgageTypes';

export const formatCurrency = (amount: number, country: Country = 'USA'): string => {
  const locale = country === 'Canada' ? 'en-CA' : 'en-US';
  const currency = country === 'Canada' ? 'CAD' : 'USD';
  
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

export const formatCurrencyWithDecimals = (amount: number, country: Country = 'USA'): string => {
  const locale = country === 'Canada' ? 'en-CA' : 'en-US';
  const currency = country === 'Canada' ? 'CAD' : 'USD';
  
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
}; 